import React from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { Select, Tooltip } from 'antd'

import { useChangeUnit } from 'hooks/useChangeUnit'

import { StyledSelect } from './styles'

const { Option } = Select

function UnitSelector() {
  const intl = useIntl()

  const unitSelected = useSelector(state => state.unitSelected.idElement)
  const allUnits = useSelector(state => state.units.data)
  const loadingTags = useSelector(state => state.tags?.loadingTags)
  const { changeUnit } = useChangeUnit()

  function formatUnitLabel(unit) {
    if (unit) {
      return `${unit.plt_codigo} - ${unit.ele_descri}`
    }

    return null
  }

  return (
    <Tooltip
      title={
        loadingTags
          ? intl.formatMessage({ id: 'global.labels.pleaseWait' })
          : ''
      }
    >
      <StyledSelect
        style={{
          width: '80%',
        }}
        value={unitSelected}
        onChange={value => changeUnit(value)}
        data-testid="unitselector-test-id"
        disabled={loadingTags}
        loading={loadingTags}
      >
        {allUnits.map(unit => (
          <Option key={unit.plt_codigo} value={unit.id_elemento}>
            {formatUnitLabel(unit)}
          </Option>
        ))}
      </StyledSelect>
    </Tooltip>
  )
}

export default UnitSelector
